<template>
  <div class="switch">
    <label :for="id">{{ label }}</label>

    <div class="onoffswitch2">
      <input
        type="checkbox"
        class="onoffswitch2-checkbox"
        :id="id"
        :checked="value"
        @change="onChange"
      />

      <label class="onoffswitch2-label" :for="id">
        <span class="onoffswitch2-inner"></span>
        <span class="onoffswitch2-switch"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "SwitchComponent",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
  },

  methods: {
    onChange(event) {
      this.$emit("input", event.target.checked);
    },
  },
};
</script>
